import React, { Component } from "react";
import { Paper, withStyles, Button } from "@material-ui/core";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./style";
import classNames from "classnames";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import ChangePackage from "./changePackage";
import Module from "./module";
import { debug } from "util";
import moment from "moment";
import PickerDate from "../../../partials/pickerDate";
import { sortPackageList } from "../../../utils/setting";
class ModulePackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package: {},
      packageName: "",
      packageCode: "",
      packageList: [],
      packageTitle: "Package",
      expiredDays: "",
      expiredDayInit: "",
      moduleRole: {},
      isSaved: true,
      haveOwner: false,
    };
  }
  handleStatusButton = (status) => {
    if (status != this.state.isSaved)
      this.setState({
        isSaved: status,
      });
  };
  componentDidMount() {
    if (this.props.adminService && this.props.adminService.no)
      this.findServiceRoleForAdmin({
        serviceCode: this.props.adminService.no,
        userCode: this.props.adminService.userCode,
      });
    this.getListPackage();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.adminService !== this.props.adminService ||
      (nextProps.adminService &&
        this.props.adminService &&
        nextProps.adminService.no !== this.props.adminService.no)
    ) {
      this.findServiceRoleForAdmin({
        serviceCode: nextProps.adminService.no,
        userCode: nextProps.adminService.userCode,
      });
    }
  }
  handleSaveModule = () => {
    let check = this.checkFullPackage(this.Module.getModule());
    let packageCode = this.state.packageCode;
    let expiredDay = "";
    if (!check) {
      let filter = this.state.packageList.find(
        (ele) => ele.packageName === "custom"
      );
      if (filter && filter.packageCode) {
        packageCode = filter.packageCode;
      } else packageCode = "";
    }
    expiredDay = this.state.expiredDays || "";
    this.updateModuleRole(packageCode, this.Module.getModule(), expiredDay);
  };
  handleResetModule = () => {
    let { expiredDayInit } = this.state;
    this.setState({ expiredDays: expiredDayInit });
    this.Module.handleShowModule(this.Module.getInitModule());
  };
  updateModuleRole = async (
    packageCode = "",
    packages = {},
    expiredDay = ""
  ) => {
    let { t, adminService = {} } = this.props;
    this.loading.startLoading();
    let check = await this.props.updateModuleRole({
      packageCode: packageCode,
      moduleRole: JSON.stringify(packages),
      expiredDay: expiredDay,
      serviceCode: adminService.no,
      userCode: adminService.userCode,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.setState({ isSaved: true });
      this.mSnackbar.handleClick(t("module_update_module_success"));
      this.findServiceRoleForAdmin({
        serviceCode: adminService.no,
        userCode: adminService.no,
      });
    } else if (check.code !== 1) {
      this.mSnackbar.handleClick(check.message, "error");
    }
  };
  checkFullPackage = (packages) => {
    let valuePackages = Object.values(packages);
    let check = 1;
    valuePackages.map((valuePackage, index) => {
      let values = Object.values(valuePackage);
      values.map((value, index) => {
        if (value === 0) {
          check = 0;
        }
      });
    });
    return check;
  };
  findServiceRoleForAdmin = async (payload = {}) => {
    let { t, adminService = {}, role = "" } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      payload.serviceCode
    ) {
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      this.loading.startLoading();
      let check = await this.props.findServiceRoleForAdmin({
        serviceCode: adminService.no,
        userCode: adminService.userCode,
        ...payload,
      });
      this.loading.stopLoading();
      if (check.code === 1 && check.data) {
        let { data = {} } = check;
        this.Module.handleShowModule(data.moduleRole);
        this.setState({
          moduleRole: data.moduleRole,
          packageCode: data.package,
          expiredDays: data.expired,
          expiredDayInit: data.expired,
          haveOwner: true,
        });
      } else if (check.error === 1159)
        this.mSnackbar.handleClick(t("module_service_have_not_owner"), "error");
      else this.mSnackbar.handleClick(check.message, "error");
    }
  };
  getListPackage = async () => {
    let check = await this.props.getListPackage();
    if (check.code === 1) {
      this.setState({
        packageList: sortPackageList(check.data),
      });
    }
  };

  // case packageList have 5 packages
  //   sortPackageList = (packageList) => {
  //     let packageListSort = [];
  //     packageList.map((packages) => {
  //       switch (packages.packageName) {
  //         case "basic": {
  //           packageListSort[0] = packages;
  //           break;
  //         }
  //         case "bronze": {
  //           packageListSort[1] = packages;
  //           break;
  //         }
  //         case "silver": {
  //           packageListSort[2] = packages;
  //           break;
  //         }
  //         case "gold": {
  //           packageListSort[3] = packages;
  //           break;
  //         }
  //         case "custom": {
  //           packageListSort[4] = packages;
  //           break;
  //         }
  //       }
  //     });
  //     return packageListSort;
  //   };
  handleOpenPickPackage = () => {
    this.ChangePackage.handleClickOpen();
  };
  handleSelectPackage = (e = {}) => {
    this.ChangePackage.handleClose();
    let check = this.checkFullPackage(e.package);
    let packageCode = e.packageCode;
    if (!check) {
      let filter = this.state.packageList.find(
        (ele) => ele.packageName === "custom"
      );
      if (filter && filter.packageCode) packageCode = filter.packageCode;
      else packageCode = "";
    }
    this.updateModuleRole(packageCode, e.package, e.expiredDay);
  };
  getFormatDate(date) {
    return moment(date).format("DD/MM/YYYY");
  }
  handleChangePickerDate = (value, nameInput) => {
    let state = this.state;
    state[nameInput] = value.valueOf();
    this.setState({ ...state, isSaved: false });
  };
  render() {
    const { classes, t } = this.props;
    const {
      isSaved,
      packageList = [],
      packageCode,
      haveOwner,
      moduleRole,
    } = this.state;
    let packages =
      packageList.find((ele) => ele.packageCode === packageCode) || {};
    let packageName = packages ? packages.packageName : "basic";
    return (
      <>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <ChangePackage
          onRef={(id) => (this.ChangePackage = id)}
          packageCode={packageCode}
          moduleRole={moduleRole}
          packageList={this.state.packageList}
          handleSelectPackage={this.handleSelectPackage}
        />
        {haveOwner ? (
          <Paper>
            <div className={classes.topBar}>
              <div className={classes.topBarLeft}>
                <div
                  className={classNames(
                    classes.packageName,
                    classes["packageName_" + packageName]
                  )}
                >
                  {packageName}
                </div>
                <div
                  className={classNames(
                    classes.arrowPackage,
                    classes["arrowPackage_" + packageName]
                  )}
                ></div>
                {/* <div className={classes.notification}>{this.state.packageTitle}</div> */}
                {this.state.expiredDays ? (
                  <div className={classes.containerExpired}>
                    <div className={classes.expiredDays}>
                      {t("module_expired_day")}
                    </div>
                    <PickerDate
                      handleChange={this.handleChangePickerDate}
                      nameInput="expiredDays"
                      time={this.state.expiredDays}
                    />
                  </div>
                ) : (
                  <div className={classes.expiredDays}>{t("module_free")}</div>
                )}

                <a
                  className={classes.link}
                  onClick={() => this.handleOpenPickPackage()}
                >
                  {t("module_change_package")}
                </a>
              </div>
              <div className={classes.topBarRight}>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  classes={{ containedPrimary: classes.colorButtonViewReport }}
                  onClick={this.handleResetModule}
                >
                  {t("module_reset")}
                </Button>
                <Button
                  disabled={isSaved}
                  className={classes.button}
                  variant="contained"
                  color="secondary"
                  onClick={this.handleSaveModule}
                >
                  {t("module_save")}
                </Button>
              </div>
            </div>
          </Paper>
        ) : (
          ""
        )}
        <Paper>
          <Module
            onRef={(id) => (this.Module = id)}
            handleStatusButton={this.handleStatusButton}
          />
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  adminService: state.service.adminService || {},
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  updateModuleRole: dispatch.serviceRole.updateModuleRole,
  getListPackage: dispatch.packages.getListPackage,
  findServiceRoleForAdmin: dispatch.serviceRole.findServiceRoleForAdmin,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: 0 })(ModulePackage))
);
